import CreditCardIcon from "./CreditCardIcon";
import PropTypes from "prop-types";
import React from "react";


const CreditCardStrip = ({classes}) => (
  <div className={classes} >
    <CreditCardIcon nameOfCard="Visa" />
    <CreditCardIcon nameOfCard="Mastercard" />
    <CreditCardIcon nameOfCard="Amex" />
    <CreditCardIcon nameOfCard="Discover" />
  </div>
);

CreditCardStrip.propTypes = {"classes": PropTypes.string};
CreditCardStrip.defaultProps = {"classes": ""};

export default CreditCardStrip;
